import { useEffect, useRef } from 'react';

const DEFAULT_AUTO_CLOSE_MS = 3000;

/**
 * Calls `onClose` after `delayMs` while `visible` is true.
 * Clears the timer when hidden, unmounted, or deps change.
 */
export function useAutoCloseOnVisible(
  visible: boolean,
  onClose: () => void,
  delayMs: number = DEFAULT_AUTO_CLOSE_MS,
): void {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!visible) {
      return;
    }

    const timerId = setTimeout(() => {
      onCloseRef.current();
    }, delayMs);

    return () => {
      clearTimeout(timerId);
    };
  }, [visible, delayMs]);
}

export const SUCCESS_DIALOG_AUTO_CLOSE_MS = DEFAULT_AUTO_CLOSE_MS;
